import { useState } from "react";
import { api } from "../../../../../../utility/api";

export const BitacoraFletesApi = () => {
    const [cargando, setCargando] = useState(false);

    const getRegistros = async (params) => {
        try {
            setCargando(true);
            const response = await api.get("bitacora_fletes_finca", params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getDatosFinca = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                "bitacora_fletes_finca/datos_finca",
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getRegistros,
        getDatosFinca,

        cargando,
    };
};
